var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGb = function SvgIconGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.48 4.693A12 12 0 0 0 .413 8.87h6.243zM23.586 8.869a12 12 0 0 0-2.067-4.176L17.344 8.87zM.413 15.13a12 12 0 0 0 2.067 4.176l4.176-4.176zM19.305 2.48A12 12 0 0 0 15.13.413v6.242zM4.693 21.518a12 12 0 0 0 4.176 2.067v-6.242zM8.869.413A12 12 0 0 0 4.693 2.48L8.87 6.655zM15.13 23.585a12 12 0 0 0 4.175-2.067l-4.175-4.175zM17.344 15.13l4.175 4.176a12 12 0 0 0 2.067-4.176z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.898 10.435H13.565V.102a12.1 12.1 0 0 0-3.13 0v10.333H.102a12.1 12.1 0 0 0 0 3.13h10.333v10.333a12.1 12.1 0 0 0 3.13 0V13.565h10.333a12.1 12.1 0 0 0 0-3.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.13 15.131 5.356 5.355q.368-.37.705-.77l-4.584-4.585zM8.87 15.131l-5.355 5.355q.37.369.77.705l4.585-4.584zM8.87 8.87 3.515 3.514a12 12 0 0 0-.705.77L7.394 8.87zM15.13 8.87l5.356-5.355a12 12 0 0 0-.77-.705L15.13 7.395z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGb;